var map = {
	"./craft-perfect-stories-introducing-two-new-story-types-for-every-need.md": [
		815,
		815
	],
	"./empowering-young-minds-the-importance-of-social-and-emotional-learning.md": [
		386,
		386
	],
	"./from-pages-to-heart-the-impact-of-personalized-storybooks-on-kids.md": [
		725,
		725
	],
	"./helping-children-navigate-big-emotions-with-personalized-stories.md": [
		856,
		856
	],
	"./image-customization-tips-for-your-enhanced-story.md": [
		558,
		558
	],
	"./innovative-ways-to-use-personalized-storybooks-for-learning.md": [
		557,
		557
	],
	"./the-neurological-power-of-stories-and-what-it-means-for-children.md": [
		985,
		985
	]
};
function webpackAsyncContext(req) {
	if(!__webpack_require__.o(map, req)) {
		return Promise.resolve().then(() => {
			var e = new Error("Cannot find module '" + req + "'");
			e.code = 'MODULE_NOT_FOUND';
			throw e;
		});
	}

	var ids = map[req], id = ids[0];
	return __webpack_require__.e(ids[1]).then(() => {
		return __webpack_require__.t(id, 1 | 16);
	});
}
webpackAsyncContext.keys = () => (Object.keys(map));
webpackAsyncContext.id = 545;
module.exports = webpackAsyncContext;